export const PEDIATRIC_TRAUMA_SCORE = {
  masterTableName: "MC_PEDIATRIC_T_SCORE",
  tableName: "MC_PEDIATRIC_T_SCORE_DET",
  columnName: "PTS_ID",
  columnValue: 0,
  title: "pediatric-trauma-score.title",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
    },
    {
      title: "HEIGHT",
      value: "HEIGHT_XNAME",
    },
    {
      title: "AIRWAY_STATUS",
      value: "AIRWAY_STATUS_XNAME",
    },
    {
      title: "CENTRAL_NERV_SYSTEM",
      value: "CENTRAL_NERV_SYSTEM_XNAME",
    },
    {
      title: "SISTOLIC_BP",
      value: "SISTOLIC_BP_XNAME",
    },
    {
      title: "OPEN_WOUND",
      value: "OPEN_WOUND_XNAME",
    },
    {
      title: "SKELETAL_INJURY",
      value: "SKELETAL_INJURY_XNAME",
    },
    {
      title: "NURSE_NOTE",
      value: "NURSE_NOTE",
    },
    {
      title: "PTS_SCORE",
      value: "PTS_SCORE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "HEIGHT", headerName: "pediatric-trauma-score.height", flex: 1 },
    {
      field: "AIRWAY_STATUS",
      headerName: "pediatric-trauma-score.airway-status",
      flex: 1,
    },
    {
      field: "CENTRAL_NERV_SYSTEM",
      headerName: "pediatric-trauma-score.central-nerv-system",
      flex: 1,
    },
    {
      field: "SISTOLIC_BP",
      headerName: "pediatric-trauma-score.sistolic-bp",
      flex: 1,
    },
    {
      field: "OPEN_WOUND",
      headerName: "pediatric-trauma-score.open-wound",
      flex: 1,
    },
    {
      field: "SKELETAL_INJURY",
      headerName: "pediatric-trauma-score.skeletal-injury",
      flex: 1,
    },
    {
      field: "NURSE_NOTE",
      headerName: "pediatric-trauma-score.pts-nurse-note",
      flex: 1,
    },
    {
      field: "PTS_SCORE",
      headerName: "pediatric-trauma-score.pts-score",
      flex: 1,
      computed: false,
      calculate: (row: any) => {
        if (!row) return 0;

        const height = Number(row.HEIGHT_XVALUE) || 0;
        const airway_status = Number(row.AIRWAY_STATUS_XVALUE) || 0;
        const central_nerv_system =
          Number(row.CENTRAL_NERV_SYSTEM_XVALUE) || 0;
        const sistolic_bp = Number(row.SISTOLIC_BP_XVALUE) || 0;
        const open_wound = Number(row.OPEN_WOUND_XVALUE) || 0;
        const skeletal_injury = Number(row.SKELETAL_INJURY_XVALUE) || 0;

        const totalScore =
          height +
          airway_status +
          central_nerv_system +
          sistolic_bp +
          open_wound +
          skeletal_injury;

        return totalScore;
      },
    },
  ],
  mcpConfig: {
    HEIGHT: { mcpId: 567, field: "HEIGHT", scoreField: "HEIGHT_XVALUE" },
    AIRWAY_STATUS: {
      mcpId: 568,
      field: "AIRWAY_STATUS",
      scoreField: "AIRWAY_STATUS_XVALUE",
    },
    CENTRAL_NERV_SYSTEM: {
      mcpId: 569,
      field: "CENTRAL_NERV_SYSTEM",
      scoreField: "CENTRAL_NERV_SYSTEM_XVALUE",
    },
    SISTOLIC_BP: {
      mcpId: 570,
      field: "SISTOLIC_BP",
      scoreField: "SISTOLIC_BP_XVALUE",
    },
    OPEN_WOUND: {
      mcpId: 571,
      field: "OPEN_WOUND",
      scoreField: "OPEN_WOUND_XVALUE",
    },
    SKELETAL_INJURY: {
      mcpId: 572,
      field: "SKELETAL_INJURY",
      scoreField: "SKELETAL_INJURY_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    PTS_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    HEIGHT: "",
    AIRWAY_STATUS: "",
    CENTRAL_NERV_SYSTEM: "",
    SISTOLIC_BP: "",
    OPEN_WOUND: "",
    SKELETAL_INJURY: "",
    NURSE_NOTE: "",
    PTS_SCORE: "",
    NURSE_ID: "",
  },
  chartScoreField: "PTS_SCORE",
  chartTimeField: "PROCESS_TIME",
};
